import {cloneDeep, get} from "lodash";
import {getString} from "Core/helpers/data";
import {LibrariesItemDataObject} from "../dataObjects";
import {getDate, getDateString, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {LibrariesItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new LibrariesItemDataObject(
		getString(result, 'id'),
		getString(result, 'libraryVersion'),
		getDate(get(result, 'libraryReleaseDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S)
	);

	return result;
}

/**
 * Get output data from input data
 * @param {LibrariesItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep(inputData);

	result = {
		releaseDate: getDateString(result.releaseDate, STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		version: result.version,
		notes: result.notes,

		// Form data properties
		appLibraryDllFile: result.appLibraryDllFormData,
		appLibraryDylibFile: result.appLibraryDylibFormData
	};

	// Set proper empty values expected by the API
	// @note This is commented out since requests that use FormData have backend issues with string values cleared by 
	// null values instead of empty strings.
	//result = resetObjectValues(result);

	return result;
}